import { defineMessages } from 'react-intl';

export default defineMessages({
  formTitle: {
    id: 'recovery_forgot_password.title',
  },
  formSubTitle: {
    id: 'recovery_forgot_password.pin-method-forgot-password.sub_title',
  },
  formSubTitlePhone: {
    id: 'recovery_forgot_password.pin-method-forgot-password.phone.sub_title',
  },
  identifiant: {
    id: 'login_page.form.identifiant',
  },
  valid: {
    id: 'recovery_forgot_password.title_button_valid',
  },
  proceedDifferently: {
    id: 'auth_by_sms.proceed_differently',
  },
  validationErrorMessage: {
    id: 'recovery_forgot_password.validation_error_message',
  },
  notYetReceived: {
    id: 'auth_by_sms.not_yet_received',
  },
});
